import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Button, InlineLoading, Modal } from 'carbon-components-react';
import { Link32, Unlink32 } from '@carbon/icons-react';

const DBYDLinkStatus: React.FC<Props> = ({
  user,
  onClickLinkAccount,
  onClickUnlinkAccount,
  isUnlinkingDBYD
}) => {
  const [isLinked, setIsLinked] = useState<boolean>(user.is_linked);
  const [localUnlinking, setLocalUnlinking] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState(false);

  const handleUnlinkClick = () => {
    setModalOpen(false);
    setLocalUnlinking(true);
    onClickUnlinkAccount();
  };

  useEffect(() => {
    if (user.is_linked && !isUnlinkingDBYD) {
      setIsLinked(true);
    } else if (!user.is_linked && !isUnlinkingDBYD) {
      setTimeout(() => {
        setIsLinked(false);
        setLocalUnlinking(false);
      }, 1500);
    }
  }, [user, isUnlinkingDBYD]);

  const appDom = document.getElementById('app');

  return (
    <div id="dbydLinkStatus" className="dbyd-link-status spacing-padding">
      <div className="sub-section-title">Before You Dig link status</div>
      <div className="section-description">
        We use this information to fetch, display and lodge enquiries in
        SmarterWX Locate
      </div>
      <div className="link-icon-container">
        {isLinked && user?.dbyd_email ? <Link32 /> : <Unlink32 />}
      </div>
      <div className="status-description-container">
        {isLinked && user?.dbyd_email ? (
          <>
            <span>Linked</span> with {user?.dbyd_email}
          </>
        ) : (
          <>Not linked</>
        )}
      </div>
      <div
        className={`action-button-container ${
          user?.is_linked && !user?.is_email_linked ? 'tertiary-danger' : ''
        }`}
      >
        {isLinked ? (
          <>
            {modalOpen &&
              appDom !== null &&
              ReactDOM.createPortal(
                <Modal
                  className="unlink-confirm-modal"
                  size="xs"
                  open={modalOpen}
                  modalHeading="Unlink your BYDA account"
                  onRequestClose={() => setModalOpen(false)}
                  onRequestSubmit={handleUnlinkClick}
                  primaryButtonText="Yes, unlink"
                  secondaryButtonText="Cancel"
                >
                  Your BYDA account will be unlinked, do you want to continue?
                </Modal>,
                appDom
              )}
            <Button
              kind="tertiary"
              size="default"
              onClick={() => setModalOpen(true)}
              disabled={isUnlinkingDBYD || localUnlinking}
            >
              {!isUnlinkingDBYD && !localUnlinking ? (
                'Unlink account'
              ) : (
                <InlineLoading
                  description={
                    !isUnlinkingDBYD
                      ? 'Account unlinked'
                      : 'Unlinking account...'
                  }
                  status={!isUnlinkingDBYD ? 'finished' : 'active'}
                  aria-live={'assertive'}
                />
              )}
            </Button>
          </>
        ) : (
          <Button
            kind="tertiary"
            size="default"
            className="button-size"
            onClick={() => onClickLinkAccount()}
          >
            Link account
          </Button>
        )}
      </div>
    </div>
  );
};

interface Props {
  user: any;
  onClickLinkAccount: Function;
  onClickUnlinkAccount: Function;
  isUnlinkingDBYD: boolean;
}

export default React.memo(DBYDLinkStatus);
